import { PortfolioReportRepository } from '../../domain/repository';
import { PortfolioReportStore, UiState } from '../../domain/store';
import { ExperienceStateType, RoundPurposeType, TargetDeviceType } from '../../domain/entity/PortfolioReportItem';

export class PortfolioReportUsecase {
  private portfolioReportRepository: PortfolioReportRepository;
  private portfolioReportStore: PortfolioReportStore;
  private uiState: UiState;

  constructor({
    portfolioReportRepository,
    portfolioReportStore,
    uiState,
  }: {
    portfolioReportRepository: PortfolioReportRepository;
    portfolioReportStore: PortfolioReportStore;
    uiState: UiState;
  }) {
    this.portfolioReportRepository = portfolioReportRepository;
    this.portfolioReportStore = portfolioReportStore;
    this.uiState = uiState;
  }

  public async getPortfolioReport(goalId: string) {
    const { portfolioReportRepository, portfolioReportStore, uiState } = this;
    uiState.clearError();
    portfolioReportStore.setLoading(true);
    const res = await portfolioReportRepository.getPortfolioReport(goalId);
    portfolioReportStore.setPortfolioReport(res);
    portfolioReportStore.setLoading(false);
  }

  public updateTargetDeviceFilter(targetDevice: TargetDeviceType) {
    const { portfolioReportStore } = this;
    if (portfolioReportStore.targetDeviceFilters.includes(targetDevice)) {
      portfolioReportStore.unsetTargetDeviceFilter(targetDevice);
    } else {
      portfolioReportStore.setTargetDeviceFilter(targetDevice);
    }
  }

  public updateStateFilter(state: ExperienceStateType) {
    const { portfolioReportStore } = this;
    if (portfolioReportStore.stateFilters.includes(state)) {
      portfolioReportStore.unsetStateFilter(state);
    } else {
      portfolioReportStore.setStateFilter(state);
    }
  }

  public updateRoundPurposeFilter(state: RoundPurposeType) {
    const { portfolioReportStore } = this;
    if (portfolioReportStore.roundPurposeFilters.includes(state)) {
      portfolioReportStore.unsetRoundPurposeFilter(state);
    } else {
      portfolioReportStore.setRoundPurposeFilter(state);
    }
  }

  public clearFilters() {
    const { portfolioReportStore } = this;
    portfolioReportStore.targetDeviceFilters.forEach(filter => {
      portfolioReportStore.unsetTargetDeviceFilter(filter);
    });
    portfolioReportStore.stateFilters.forEach(filter => {
      portfolioReportStore.unsetStateFilter(filter);
    });
    portfolioReportStore.roundPurposeFilters.forEach(filter => {
      portfolioReportStore.unsetRoundPurposeFilter(filter);
    });
  }

  public getTargetDeviceFiltersFromUrl() {
    this.portfolioReportRepository.getTargetDeviceFiltersFromUrl();
  }

  public getStateFiltersFromUrl() {
    this.portfolioReportRepository.getStateFiltersFromUrl();
  }

  public getRoundPurposeFiltersFromUrl() {
    this.portfolioReportRepository.getRoundPurposeFiltersFromUrl();
  }

  public setInitialTargetDeviceFilters() {
    const { portfolioReportRepository, portfolioReportStore } = this;
    const filters = portfolioReportRepository.getTargetDeviceFiltersFromUrl();
    filters.forEach(filter => {
      portfolioReportStore.setTargetDeviceFilter(filter);
    });
  }

  public setInitialStateFilters() {
    const { portfolioReportRepository, portfolioReportStore } = this;
    const filters = portfolioReportRepository.getStateFiltersFromUrl();
    filters.forEach(filter => {
      portfolioReportStore.setStateFilter(filter);
    });
  }

  public setInitialRoundPurposeFilters() {
    const { portfolioReportRepository, portfolioReportStore } = this;
    const filters = portfolioReportRepository.getRoundPurposeFiltersFromUrl();
    filters.forEach(filter => {
      portfolioReportStore.setRoundPurposeFilter(filter);
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/application/usecase/PortfolioReportUsecase.ts